<template>
    <section>
        <div class="wrapper wrapper-content">
            <div style="margin: 0" v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
                <div class="sk-bounce1"></div>
                <div class="sk-bounce2"></div>
                <div class="sk-bounce3"></div>
            </div>
            <div class="row"  v-if="menu.length > 0"  id="main-content">
                <div class="col-md-12">
                    <div class="ibox-content">
                        <PosReceipt ref="posReceipt" id="pos" style="display:none" v-if="selectedTableOrder.orderItemsById.length>0"
                             v-bind:selectedTable="selectedTable"
                              v-bind:selectedTableOrder="selectedTableOrder"
                              v-bind:orderCreatedtime="$parent.orderHistory.created"></PosReceipt>
                        <div class="row">
                            <h2>Selected Table: <b>{{this.selectedTable.name}}--{{(this.selectedTableOrder.waiter === null) ? 'No Waiter' : this.selectedTableOrder.waiter.name}}</b></h2>
                        </div>
                        <div class="row">
                            <div class="col-md-2 category_panel">
                                <div class="theiaStickySidebar">
                                    <div class="panel panel-primary ">
                                        <div class="panel-heading">
                                            <b>Menu Categories</b>
                                        </div>
                                        <div class="panel-body" id="menu category_nav_bar">
                                            <ul class="nav">
                                                <li><a href="#most_popular">Most Popular</a></li>
                                                <li v-for="(category, index) in menu" v-if="!category.deleted"  v-bind:key="index+'cat_sidebar'">
                                                    <a v-bind:href="'#' + category.name.replace(/[ /]/g, '')" v-bind:title="category.name" v-bind:class="(category.name.length > 17) ? 'myTip link' : 'link'">{{(category.name.length > 17) ? category.name.substring(0,17)+'...' : category.name}}</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="panel panel-primary" >
                                    <div class="panel-heading">
                                        <b>Items</b>
                                    </div>
                                    <div class="panel-body">
                                        <multiselect v-model="multiselectSelectedItem"
                                                     :options="this.$parent.itemOptions"
                                                     :custom-label="customLabel" :track-by="this.$parent.itemOptions.serving"
                                                     @input="findAdOnCategoriesOfItemType(multiselectSelectedItem)"
                                                     >
                                        </multiselect>
                                        <section>
                                            <h3 id="most_popular" class="text-success"><b>Most Popular</b></h3>
                                            <ul class="list-group" >
                                                <template v-for="(mCategory) in menu" >
                                                    <li class="list-group-item list-group-item-info" v-for="(menuItem,indexMenuItem) in mCategory.menuItemsById" v-if="menuItem.mostPopular && !menuItem.deleted" v-bind:key="indexMenuItem+'_popular_'+menuItem.name">
                                                        <div class="row">
                                                            <div class="col-md-7">
                                                                <b>{{menuItem.name}}</b>
                                                                <p>{{menuItem.description}}</p>
                                                            </div>
                                                            <div class="col-md-5">
                                                                <table class="menu_table hideTableBottom table table-hover">
                                                                    <tbody>
                                                                    <tr v-for="(menuItemType, indexMenuItemType) in menuItem.menuItemTypesById" v-bind:key="indexMenuItemType+'type_popular'">
                                                                        <td>{{menuItemType.serving}}</td>
                                                                        <td class="text-center">{{menuItemType.price}} Rs.</td>
                                                                        <td class="text-right">
                                                                            <button v-on:click="showAdOns(menuItem, menuItemType, mCategory.name)" class="btn btn-sm btn-primary">Select</button>
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </template>
                                            </ul>
                                        </section>
                                        <section v-for="(mCategory, index) in menu" v-if="!mCategory.deleted" v-bind:key="index+'cat_main_menu'">
                                            <h3 v-bind:id="mCategory.name.replace(/[ /]/g, '')" class="text-success"><b>{{mCategory.name}}</b></h3>
                                            <ul class="list-group">
                                                <li class="list-group-item list-group-item-info" v-for="(menuItem,indexMenuItem) in mCategory.menuItemsById" v-if="!menuItem.deleted" v-bind:key="indexMenuItem+'item_main_menu'">
                                                    <div class="row">
                                                        <div class="col-md-7">
                                                            <b>{{menuItem.name}}</b>
                                                            <p>{{menuItem.description}}</p>
                                                        </div>
                                                        <div class="col-md-5">
                                                            <table class="menu_table hideTableBottom table table-hover">
                                                                <tbody>
                                                                <tr v-for="(menuItemType, indexMenuItemType) in menuItem.menuItemTypesById" v-if="!menuItemType.deleted" v-bind:key="indexMenuItemType+'type_main_menu'">
                                                                    <td>{{menuItemType.serving}}</td>
                                                                    <td class="text-center">{{menuItemType.price}} Rs.</td>
                                                                    <td class="text-right">
                                                                            <button v-on:click="showAdOns(menuItem, menuItemType, mCategory.name)" class="btn btn-sm btn-primary">Select</button>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </section>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-5 cart_panel" id="print">
                                <div class="theiaStickySidebar">
                                    <div class="panel panel-primary">
                                        <div class="panel-heading">
                                            <b>Cart</b>
                                            <a title="Discard Order" style="color: #FFF;" class="myTip pull-right"  @click="discardOrder()"><b><i class="fa fa-times"></i> Cancel Order</b></a>
                                        </div>
                                        <div class="panel-body">
                                            <div class="table-responsive">
                                                <table class="table table-hover cart_table hideTableBottom table-condensed">
                                                    <thead>
                                                        <tr style="white-space: nowrap;" >
                                                            <th>Quantity</th>
                                                            <th>Item</th>
                                                            <th class="text-center">Serving</th>
                                                            <th class="text-right">Total Price</th>
                                                            <th class="text-right"><i class="fa fa-bolt"></i></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                   <template v-for="(orderItem, orderItemIndex) in this.selectedTableOrder.orderItemsById" >
                                                            <tr v-bind:key="orderItemIndex">
                                                                <td>
                                                                    <div class="input-group spinner" style="max-width: 60px">
                                                                        <input type="text" readonly="readonly" class="form-control" v-bind:value="orderItem.quantity">
                                                                        <div class="input-group-btn-vertical">
                                                                            <button class="btn btn-primary" type="button" v-on:click="updateOrderItemQuantity(orderItemIndex, 'inc')"><i class="fa fa-caret-up"></i></button>
                                                                            <button class="btn btn-primary" type="button" v-on:click="updateOrderItemQuantity(orderItemIndex, 'dec')"><i class="fa fa-caret-down"></i></button>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td class="increaseLineHeight" >
                                                                    <a style="white-space: pre-wrap" v-bind:title="(orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name + ', ' +orderItem.menuItemTypesByMenuItemTypeId.serving + '(' + orderItem.menuItemTypesByMenuItemTypeId.price + 'Rs. )')"><b class="text-success">{{orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name}} </b></a>
                                                                    <a v-if="orderItem.orderItemAddOnsById.length > 0" v-on:click="editOrderItemInCart(orderItem, orderItemIndex, false)"> - <i class="fa fa-pencil"></i></a>
                                                                </td>
                                                                <td class="text-center increaseLineHeight">{{orderItem.menuItemTypesByMenuItemTypeId.serving}}</td>
                                                                <td class="text-right increaseLineHeight">{{orderItem.totalPrice | formatNumber}} Rs.</td>
                                                                <td class="text-right increaseLineHeight"><button type="button" v-on:click="removeItemFromCart(orderItemIndex)" class="btn btn-xs btn-danger"><i class="fa fa-times"></i></button></td>
                                                            </tr>
                                                            <template v-for="(itemAddOn, itemAddOnIndex) in orderItem.orderItemAddOnsById">
                                                                <tr v-bind:key="orderItemIndex+'_'+itemAddOnIndex">
                                                                    <td colspan="2">
                                                                        <div class="input-group spinner pull-right" style="max-width: 60px">
                                                                            <input type="text" readonly="readonly" class="form-control" v-bind:value="itemAddOn.quantity">
                                                                            <div class="input-group-btn-vertical">
                                                                                <button class="btn btn-primary" v-on:click="updateAdOnQuantity(orderItemIndex,itemAddOnIndex,'inc')" type="button"><i class="fa fa-caret-up"></i></button>
                                                                                <button class="btn btn-primary" v-on:click="updateAdOnQuantity(orderItemIndex,itemAddOnIndex,'dec')" type="button"><i class="fa fa-caret-down"></i></button>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td class="text-center increaseLineHeight">{{itemAddOn.addOnItemsByAddOnItemId.name}}</td>
                                                                    <td class="text-right increaseLineHeight" colspan="1">{{(itemAddOn.quantity * itemAddOn.addOnItemsByAddOnItemId.price) | formatNumber}} Rs.</td>
                                                                </tr>
                                                            </template>
                                                            <tr v-bind:key="orderItemIndex+'_'" style="border-bottom: solid 1px #CCCCCC">
                                                                <td colspan="5" class="instruction_text">
                                                                    <p class="text-danger" v-bind:title="orderItem.instructions">{{(orderItem.instructions === null) ? '' : orderItem.instructions}}</p>
                                                                </td>
                                                            </tr>
                                                        </template>
                                                        <tr v-if="this.selectedTableOrder.orderItemsById.length === 0">
                                                            <td colspan="5">No Item In Cart!</td>
                                                        </tr>
                                                    <template v-if="this.selectedTableOrder.orderItemsById.length !== 0">
                                                            <tr>
                                                            <td colspan="3" class="text-right">Subtotal:</td>
                                                            <td class="text-right"><b>{{this.selectedTableOrder.totalPrice | formatNumber}} Rs.</b></td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="3" class="text-right">Subtotal With AdOn's:</td>
                                                                <td class="text-right"><b>{{this.selectedTableOrder.totalPriceWithAddon | formatNumber}} Rs.</b></td>
                                                            </tr>
                                                            <tr>
                                                            <td colspan="3" class="text-right">Billed Price</td>
                                                            <td class="text-right text-success" style="font-size: 15px"><b>{{this.selectedTableOrder.totalPriceWithAddon | formatNumber}} Rs.</b></td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <hr/>
                                            <div v-if="this.selectedTableOrder.orderItemsById.length !== 0">
                                                <!-- <div class="col-md-4 text-center">
                                                    <button type="button" class="btn btn-info" @click="sendToKitchen()" :disabled="selectedTableOrder.orderHistoriesById.length>1" :id="this.selectedTable.id">Send To Kitchen</button>
                                                </div> -->
                                                <div class="pull-right">
                                                    <button type="button" class="btn btn-success" @click="print()">Print Bill</button> 
                                                </div>
                                                <div class="pull-right" style="margin-right:10px">
                                                    <button type="button" class="btn btn-primary" @click="finalizeOrder()">Finish Order</button>
                                                </div>                                                                                                
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
         <!-- Ad - On Modal -->
        <div class="modal fade" id="adOnsPopUp" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title" id="adOnsPopUpLabel">Select Ad'On of <b>{{this.selectedMenuItem.name}} ({{this.selectedMenuItemType.serving}})</b>
                        <span style="float:right; margin-right:10px;"><b>Total Price: {{this.adonModalTotal}}</b></span>
                        </h4>
                    </div>
                    <div class="modal-body row">
                        <section class="col-md-6" v-for="adOnCat in selectedMenuItemTypeAdOns" v-if="!adOnCat.deleted" v-bind:key="'itemTypeAdon_cat_modal_' + adOnCat.id + Math.random()">
                            <b>{{adOnCat.addOnCategory.name.split('-->')[0] + ' (' + adOnCat.addOnCategory.allowedItems + ')'}}</b><b class="text-danger small" v-if="adOnCat.addOnCategory.required"> (required)</b>
                            <div class="checkbox" v-for="adOnName in adOnCat.addOnCategory.addOnItemsById" v-bind:key="'itemTypeAdon_cat_item_modal_'+adOnName.id + Math.random()">
                                <label>
                                    <input type="checkbox" v-bind:checked="checkSelectedAdOns(adOnName.id)" v-on:click="checkAdOnLimitAndAddAdOn(adOnCat.addOnCategory.allowedItems, adOnName.id, adOnCat.addOnCategory.id, $event,adOnName, adOnCat)"/> {{adOnName.name + ' - ' + adOnName.price + ' Rs.'}}
                                </label>
                            </div>
                        </section>
                        <section class="col-md-6" v-for="adOnCat in selectedAdOnCategory" v-if="!adOnCat.deleted" v-bind:key="'adon_cat_modal_' + adOnCat.id + Math.random()">
                            <b>{{adOnCat.addOnCategory.name.split('-->')[0] + ' (' + adOnCat.addOnCategory.allowedItems + ')'}}</b><b class="text-danger small" v-if="adOnCat.addOnCategory.required"> (required)</b>
                            <div class="checkbox" v-for="adOnName in adOnCat.addOnCategory.addOnItemsById" v-bind:key="'adon_cat_item_modal_'+adOnName.id + Math.random()">
                                <label>
                                    <input type="checkbox" v-bind:checked="checkSelectedAdOns(adOnName.id)" v-on:click="checkAdOnLimitAndAddAdOn(adOnCat.addOnCategory.allowedItems, adOnName.id, adOnCat.addOnCategory.id, $event, adOnName, adOnCat)"/> {{adOnName.name + ' - ' + adOnName.price + ' Rs.'}}
                                </label>
                            </div>
                        </section>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button v-if="!editOrderItem" type="button" v-on:click="addOrderItem()" class="btn btn-primary">Add To Cart</button>
                        <button v-if="editOrderItem" type="button" v-on:click="editOrderItemInCart(null, null, true)" class="btn btn-primary">Update Cart</button>
                    </div>
                </div>
            </div>
        </div>
        <FinalizeOrder v-bind:order="selectedTableOrder" ref="finalizeOrder"/>
    </section>
</template>

<script>
    import User from '@/services/User'
    import Multiselect from 'vue-multiselect';
    // import posReceipt from './receipt';
    import PosReceipt from './Receipt';
    import FinalizeOrder from '@/components/pos/FinalizeOrderPopup'
    export default {
        name: "BranchMenu",
        props:["menu","selectedTableOrder","selectedBranch", "selectedTable"],
        data: function () {
            return {
                flex:"",
                restaurants: [],
                branches: [],
                selectedRestaurant: "",
                isHideSpinner: "hide",
                selectedAdOnCategory: [],
                noAdOns: false,
                adOnSelection: {},
                requiredAdOns:[],
                selectedMenuItemTypeAdOns: [],
                selectedMenuItem:"",
                addOns:[],
                selectedMenuItemType:"",
                selectedMenuCategory:"",
                multiselectSelectedItem:"",
                selectedOrderItemIndexForEdit: -1,
                editOrderItem:false,
                editOrderItemIndex:"",
                checkedAddOns:[],
                selectedAdOns:[],
                adonModalTotal:0,
                inputValue: 0,
                orderItemAddon:{
                        id:0,
                        quantity:1,
                        addOnItemsByAddOnItemId:{
                            id:0,
                            name:"",
                            price:"",
                            addOnCategoriesByAddOnCategoryId:{
                                id:0,
                                name:"",
                                allowedItems:0,
                                required:false
                            }
                        }
                    },
            }
        },
        components:{PosReceipt,Multiselect, FinalizeOrder},
        watch: {
            //watch to check for required addons
            selectedMenuItemTypeAdOns: function() {
                for(let key in this.selectedMenuItemTypeAdOns){
                    if ( this.selectedMenuItemTypeAdOns.hasOwnProperty(key) ) {
                        (this.selectedMenuItemTypeAdOns[key].addOnCategory.required) && (this.requiredAdOns.push(this.selectedMenuItemTypeAdOns[key].addOnCategory.id.toString()));
                    }
                }
            },
            selectedAdOnCategory: function() {
                for(let key in this.selectedAdOnCategory){
                    if ( this.selectedAdOnCategory.hasOwnProperty(key) ) {
                        (this.selectedAdOnCategory[key].addOnCategory.required) && (this.requiredAdOns.push(this.selectedAdOnCategory[key].addOnCategory.id.toString()));
                    }
                }
            },
        },
        computed: {
            adOns: function () {
                if (this.selectedAdOnCategory.name) { return this.selectedAdOnCategory.menuItemAdOns }
                else if (this.selectedAdOnCategory.serving) { return this.selectedAdOnCategory.menuItemTypeAdOns }
            }
        },
            updated: function () {
            $('.i-checks').iCheck({
                checkboxClass: 'icheckbox_square-green',
                radioClass: 'iradio_square-green',
            });

        $('#adOnsPopUp').on('hidden.bs.modal', function (e) { //reseting values if model hide
            this.selectedAdOns=[];
            this.selectedAdOnCategory=[];
            this.selectedMenuItemTypeAdOns=[];
            this.adOnSelection=[];
            this.addOns= $.extend(true,[],[]);
            this.editOrderItem=false;
            // this.selectedwaiter="";
        });
        },
        methods: {
            customLabel: function (opt){ //label to show in menu search bar
                return `${opt.categoryName} — ${opt.itemName} - ${opt.serving}`;
            },
            findAdOnCategoriesOfItemType: function (menuItem) { //method to show addons if item selected from menu search bar
                    this.showAdOns(menuItem.menuItem, menuItem.menuItemType, menuItem.categoryName);
                    this.multiselectSelectedItem=null;
            },
            showAdOns: function(menuItem, menuItemType, categoryName) { //method to show addons of selected item if exist
                this.addOns= $.extend(true,[],[]);
                this.editOrderItem=false;
                this.selectedAdOns=[];
                this.adOnSelection=[];
                this.selectedMenuItem= menuItem;
                this.selectedMenuItemType= menuItemType;
                this.selectedMenuCategory= categoryName;
                this.selectedMenuItemTypeId = menuItemType.id;
                
                if(menuItem.menuItemAdOns.length === 0 && menuItemType.menuItemTypeAdOns.length === 0){
                    this.requiredAdOns = [];
                    this.addOrderItem();
                }else{
                    this.selectedAdOnCategory = $.extend(true, {}, menuItem.menuItemAdOns); //menu item level addons
                    this.selectedMenuItemTypeAdOns = $.extend(true, {}, menuItemType.menuItemTypeAdOns); //menu item-type addon
                    this.requiredAdOns = [];
                    this.calculateFinanceForAdonModal();
                    $("#adOnsPopUp").modal("show");
                }
            },
            checkSelectedAdOns: function (selectedAdOnId) { //method to check selected addons in addons popup
                for (let a in this.adOnSelection){
                    for (let aid of this.adOnSelection[a]){
                        if (aid === selectedAdOnId){
                            return true;
                        }
                    }
                }
                return false;
            },
            checkAdOnLimitAndAddAdOn: function(limit, adOnItemId, adOnCategoryId, e, adOnName, adOnCat) { //check adon limit and populate addon array of item
               if(this.addOns.length===0){
                   this.addOns= $.extend(true,[],[]);
               }
                let existingAdOns = this.adOnSelection[adOnCategoryId];
                this.resetOrderItemAdon;
                var adOnObjct = $.extend(true,{},this.orderItemAddon);  //creating a copy of adon object and push in addon array
                adOnObjct.addOnItemsByAddOnItemId.id=adOnName.id;
                adOnObjct.addOnItemsByAddOnItemId.name=adOnName.name;
                adOnObjct.addOnItemsByAddOnItemId.price=adOnName.price;
                adOnObjct.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.id= adOnCat.addOnCategory.id;
                adOnObjct.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.name= adOnCat.addOnCategory.name;
                adOnObjct.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.allowedItems= adOnCat.addOnCategory.allowedItems;
                adOnObjct.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.required= adOnCat.addOnCategory.required;

                if(e.target.checked){
                    if(existingAdOns === undefined){
                        this.adOnSelection[adOnCategoryId] = [];
                        this.adOnSelection[adOnCategoryId].push(adOnItemId);
                        this.addOns.push(adOnObjct);
                        // this.selectedAdOns.push(adOnObjct);
                        
                    }else if(existingAdOns.length === limit){
                        swal("ERROR!", "You can not add more ad ons!", "error");
                        e.target.checked = false;
                    }else{
                        this.adOnSelection[adOnCategoryId].push(adOnItemId);
                        this.addOns.push(adOnObjct);
                        // this.selectedAdOns.push(adOnObjct);
                    }
                }else{
                    for(let i in this.addOns){
                        if(this.addOns[i].addOnItemsByAddOnItemId.id=== adOnItemId){
                            this.addOns.splice(i, 1);
                        }
                    };
                    let index = existingAdOns.indexOf(adOnItemId);
                    if (index > -1) {
                        existingAdOns.splice(index, 1);
                    }
                }
                this.calculateFinanceForAdonModal();
            },
            calculateFinanceForAdonModal: function (){
                this.adonModalTotal=this.selectedMenuItemType.price;
                if(this.addOns.length>0){
                    for(var adonPrice of this.addOns){
                        this.adonModalTotal= this.adonModalTotal+adonPrice.addOnItemsByAddOnItemId.price;
                    }
                }
                

            },
            addOrderItem: function () { //add order item in cart
                let adOns=[]; //here check if all required addons are checked
                let required = [];
                for (var key in this.adOnSelection) {
                    if (this.adOnSelection.hasOwnProperty(key) && this.adOnSelection[key].length > 0) {
                        required.push(key.toString());
                        adOns.push(this.adOnSelection[key]);
                    }
                }
                this.selectedAdOns= $.extend(true,[],this.addOns); //copy selected/edited addons in selectedadons
                if (this.requiredAdOns.every((i) => required.includes(i))){ //check for requied addons
                
                var objct = $.extend(true,{},this.$parent.orderItem);
                objct.totalPrice= this.selectedMenuItemType.price * objct.quantity;
                objct.menuItemTypesByMenuItemTypeId.id=this.selectedMenuItemTypeId;
                objct.menuItemTypesByMenuItemTypeId.price= this.selectedMenuItemType.price;
                objct.menuItemTypesByMenuItemTypeId.serving=this.selectedMenuItemType.serving;
                objct.orderItemAddOnsById= this.selectedAdOns;

                objct.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.id= this.selectedMenuItem.id;
                objct.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name= this.selectedMenuItem.name;
                objct.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.menuCategoriesByMenuCategoryId.name= this.selectedMenuCategory;

                this.selectedTableOrder.orderItemsById.push(objct); //push the addon object in array of order item
                let price= this.selectedTableOrder.totalPrice;
                this.selectedTableOrder.totalPrice= this.selectedTableOrder.totalPrice +  this.selectedMenuItemType.price;
                this.calculateFinance();
                
                this.selectedMenuItemTypeAdOns=[];
                this.selectedAdOnCategory=[];
                this.adOnSelection=[];
                this.selectedAdOns=[];
                $("#adOnsPopUp").modal("hide");
                this.calculateFinance();
            }else { swal("Warning!","Make Sure at least One option of each Required Ad'On(s) is Selected", "warning") }
            },
            removeItemFromCart: function(orderItemIndex){ //remove item from cart -->1) remove from selected order then write this order to localstorage
                this.selectedTableOrder.totalPrice= this.selectedTableOrder.totalPrice - this.selectedTableOrder.orderItemsById[orderItemIndex].menuItemTypesByMenuItemTypeId.price * this.selectedTableOrder.orderItemsById[orderItemIndex].quantity;
                this.selectedTableOrder.orderItemsById.splice(orderItemIndex,1);
                this.calculateFinance();
            },
            updateOrderItemQuantity: function(orderItemIndex,operation){ //update qunatity of order item
                switch (operation) {
                    case 'inc':
                        if(this.selectedTableOrder.orderItemsById[orderItemIndex].quantity < 50){
                            this.selectedTableOrder.orderItemsById[orderItemIndex].quantity += 1;
                            this.selectedTableOrder.orderItemsById[orderItemIndex].totalPrice= this.selectedTableOrder.orderItemsById[orderItemIndex].menuItemTypesByMenuItemTypeId.price * this.selectedTableOrder.orderItemsById[orderItemIndex].quantity;
                        }
                        break;
                    case 'dec':
                        if(this.selectedTableOrder.orderItemsById[orderItemIndex].quantity > 1){
                            this.selectedTableOrder.orderItemsById[orderItemIndex].quantity -= 1;
                            this.selectedTableOrder.orderItemsById[orderItemIndex].totalPrice= this.selectedTableOrder.orderItemsById[orderItemIndex].menuItemTypesByMenuItemTypeId.price * this.selectedTableOrder.orderItemsById[orderItemIndex].quantity;
                        }
                        break;
                }
                this.calculateFinance();
            },
            updateAdOnQuantity: function(orderItemIndex,itemAddOnIndex, operation){  //update qunatity of order item addons
                switch (operation) {
                    case 'inc':
                        if(this.selectedTableOrder.orderItemsById[orderItemIndex].orderItemAddOnsById[itemAddOnIndex].quantity < 50){
                            this.selectedTableOrder.orderItemsById[orderItemIndex].orderItemAddOnsById[itemAddOnIndex].quantity += 1;
                        }
                        break;
                    case 'dec':
                        if(this.selectedTableOrder.orderItemsById[orderItemIndex].orderItemAddOnsById[itemAddOnIndex].quantity > 1){
                            this.selectedTableOrder.orderItemsById[orderItemIndex].orderItemAddOnsById[itemAddOnIndex].quantity -= 1;
                        }
                        break;
                }
                this.calculateFinance();
            },
            showAdOnsOfCart: function(menuItem, menuItemType, categoryName) { //show addons of cart
                this.editOrderItem=true;
                var menu_item = $.extend(true, {}, menuItem);
                var menu_item_type= $.extend(true, {}, menuItemType);
                this.selectedMenuItem= menu_item;
                this.selectedMenuItemType= menu_item_type;
                this.selectedMenuCategory= categoryName;
                this.selectedMenuItemTypeId = menu_item_type.id;
                
                if(menu_item.menuItemAdOns.length === 0 && menu_item_type.menuItemTypeAdOns.length === 0){
                    this.requiredAdOns = []
                    this.addOrderItem();
                }else{
                    this.selectedAdOnCategory = $.extend(true, {}, menu_item.menuItemAdOns);
                    this.selectedMenuItemTypeAdOns = $.extend(true, {}, menu_item_type.menuItemTypeAdOns);
                    this.calculateFinanceForAdonModal();
                    $("#adOnsPopUp").modal("show");
                }
            },
            editOrderItemInCart: function (orderItem, orderItemIndex, onlyUpdate) { //calls whan pencil of orderitem in cart clicked
                if(!onlyUpdate){
                    this.selectedAdOnCategory=[];
                    this.selectedMenuItemTypeAdOns=[];
                    this.adOnSelection=[];
                    this.editOrderItemIndex= orderItemIndex;
                    this.selectedAdOns= orderItem.orderItemAddOnsById;
                    for(let orderItemAdon of orderItem.orderItemAddOnsById){
                        if(this.adOnSelection[orderItemAdon.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.id] === undefined){
                            this.adOnSelection[orderItemAdon.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.id] = [];
                        }
                        this.adOnSelection[orderItemAdon.addOnItemsByAddOnItemId.addOnCategoriesByAddOnCategoryId.id].push(orderItemAdon.addOnItemsByAddOnItemId.id);
                    }
                    for(let menuCategory of this.menu){ //finding menu item of order item to get all addons to show in popup
                        for(let menuItem of menuCategory.menuItemsById){
                            for(let menuItemType of menuItem.menuItemTypesById){
                                if(menuItem.id === orderItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.id && menuItemType.id ===orderItem.menuItemTypesByMenuItemTypeId.id){
                                    this.addOns= $.extend(true,[],this.selectedTableOrder.orderItemsById[this.editOrderItemIndex].orderItemAddOnsById);
                                    this.showAdOnsOfCart(menuItem, menuItemType, menuCategory.name);
                                }
                            }
                        }
                    }
                }else{
                    console.log("Updating Cart..."); //when update cart clicked
                    this.selectedTableOrder.orderItemsById[this.editOrderItemIndex].orderItemAddOnsById=$.extend(true,[],this.addOns);
                    let adOns=[];
                    let required = [];
                    for (var key in this.adOnSelection) { //prepare to check for all required addons
                        if(this.adOnSelection.hasOwnProperty(key) && this.adOnSelection[key].length > 0){
                            required.push(key.toString());
                            adOns.push(this.adOnSelection[key]);
                        }
                    }                   
                    if (this.requiredAdOns.every((i) => required.includes(i))){
                        this.calculateFinance();
                        // this.editOrderItem = false;
                        this.editOrderItem=false;
                        $("#adOnsPopUp").modal("hide");
                    }else{ swal("Warning!","Make Sure at least One option of each Required Ad'On(s) is Selected", "warning") }
            }
            },
            calculateFinance: async function(){ //calculate finance of selected order object
                let totalprice= 0;
                let addonprice=0;
                let temp=0;
                for(let order of this.selectedTableOrder.orderItemsById){
                    temp= order.menuItemTypesByMenuItemTypeId.price * order.quantity;
                    totalprice= totalprice + temp;
                    for(let addon of order.orderItemAddOnsById){
                        addonprice=addonprice+ (addon.addOnItemsByAddOnItemId.price* addon.quantity);
                    }
                }
                this.selectedTableOrder.totalPrice= totalprice;
                this.selectedTableOrder.totalPriceWithAddon= addonprice + totalprice;
                if(this.selectedTableOrder.couponsByCouponId!==null){
                    if(this.selectedTableOrder.couponsByCouponId.inPercentage){
                        this.selectedTableOrder.discount= Math.round((this.selectedTableOrder.totalPriceWithAddon /100)*this.selectedTableOrder.couponsByCouponId.discount);
                    }else{
                        this.selectedTableOrder.discount= this.selectedTableOrder.couponsByCouponId.discount;
                    } 
                }

                if(this.selectedTableOrder.paymentMethod.id===1){
                    this.selectedTableOrder.totalPriceAfterTax= Math.round(this.selectedTableOrder.totalPriceWithAddon + (this.selectedTableOrder.totalPriceWithAddon/100)*this.selectedBranch.tax);
                    this.selectedTableOrder.billedPrice= Math.round(this.selectedTableOrder.totalPriceAfterTax - this.selectedTableOrder.discount);
                }
                else if(this.selectedTableOrder.paymentMethod.id===2){
                    this.selectedTableOrder.totalPriceAfterTax= this.selectedTableOrder.totalPriceWithAddon + (this.selectedTableOrder.totalPriceWithAddon/100)*this.selectedBranch.cardTax;
                    // this.selectedTableOrder.billedPrice= this.selectedTableOrder.totalPriceAfterTax; //need to think whether to calculate billed price here or not
                    this.selectedTableOrder.billedPrice= Math.round(this.selectedTableOrder.totalPriceAfterTax - this.selectedTableOrder.discount);
               }
                await this.$parent.updateOrderObject(this.selectedTableOrder, this.selectedTable.id);
                
            },
            resetOrderItemAdon(){ //reset order model
                this.orderItemAddon={
                        id:0,
                        quantity:1,
                        addOnItemsByAddOnItemId:{
                            id:0,
                            name:"",
                            price:"",
                            addOnCategoriesByAddOnCategoryId:{
                                id:0,
                                name:"",
                                allowedItems:0,
                                required:false
                            }
                        }
                    }
            },
            sendToKitchen: async function(){  //add status in order object and disable send to kitchen button
                console.log("Sent to kitchen");
                var statusObject = $.extend(true, {}, this.$parent.orderHistory);
                const date= new Date;
                statusObject.created= date.toISOString();
                statusObject.statusesByStatusId.id=21;
                statusObject.statusesByStatusId.name="SENT TO KITCHEN";
                // this.selectedTableOrder.orderHistoriesById.push(statusObject);
                await this.$parent.updateOrderObject(this.selectedTableOrder, this.selectedTable.id);
            },
            print: function(){
                const WinPrint =window.open('', '', 'left=0,top=0,width=400,height=500px,toolbar=0,scrollbars=0,status=0');
                WinPrint.document.write(document.getElementById('pos').innerHTML) ;;
                WinPrint.document.close();
                WinPrint.focus();
                WinPrint.print();
                setTimeout(()=>{
                    WinPrint.close();     
                },500)
            },
            finalizeOrder: function(){ //popup finalize order modal
                this.$refs.finalizeOrder.load(this.selectedTableOrder, this.selectedTable);
            },
            submitOrderObject: function(){ //submit the selected order object to engine to save this
            if(this.selectedTableOrder.paymentMethod.id===2){
                this.inputValue= this.selectedTableOrder.billedPrice;
            }
            else{
                this.inputValue='';
            }
            const { value: cashTaken} = Swal.fire({
                title: "Cash Taken",
                text: 'Total Cash: ' + this.selectedTableOrder.billedPrice,
                input: 'text',
                inputLabel: 'Cash Taken',
                inputValue: this.inputValue,
                showCancelButton: true,
                confirmButtonText: 'Punch',
                showLoaderOnConfirm: true,
                preConfirm: (cashtaken) => {
                    this.$parent.selectedTableOrder.cashTaken=cashtaken
                    this.$parent.selectedTableOrder.cashGiven= cashtaken-this.$parent.selectedTableOrder.billedPrice;
                    let orderCreated= this.selectedTableOrder.orderHistoriesById[0];
                    this.selectedTableOrder.orderHistoriesById=[];
                    this.$http.post(this.$store.state.mainAppURL + 'pos/save_pos_order/', this.selectedTableOrder).then(resp=>{
                        this.$parent.selectedTableOrder.id= resp.data.id;
                        let param1= new URLSearchParams();
                        param1.append("order_id", resp.data.id);
                        param1.append("status_id", 20);
                        param1.append("created", orderCreated.created);
                        this.$http.post(this.$store.state.mainAppURL + 'pos/add_status_of_pos_order/', param1).then(resp=>{
                            console.log("Saved");
                            this.print();
                            this.$parent.selectedTable.status= 0;
                            let param= new URLSearchParams();
                            param.append("table_id", this.$parent.selectedTable.id);
                            param.append("table_status", this.$parent.selectedTable.status);
                            this.$http.post(this.$store.state.mainAppURL + "pos/update_table_status", param).then(resp=>{
                                console.log("Table Updated");
                                localStorage.removeItem(this.selectedBranch.id + "_" +this.selectedTable.id);
                                $("#"+ this.selectedTable.id).removeClass("red-bg");
                                $("#finalize_order").modal('hide');
                                swal("SUCCESS!", "Order has been saved successfully", "success");
                                this.$parent.selectedTable.status=""
                            })
                        });
                    })
                },
                allowOutsideClick: () => !Swal.isLoading(),
                inputValidator: (value) => {
                    if (!value) {
                    return 'Enter The Amount Taken From Customer'
                    }
                    else if(value< this.selectedTableOrder.billedPrice){
                        return 'Collected Amount is less then Total Amount'
                    }
                }
            })

            },
            discardOrder: function () { //remove order from localstorage also update status of table in database
                console.log("Discard");
                Swal({
                    title: 'Are you sure?',
                    text: "Are you sure you want to cancel this order! This will delete all order data from cache.",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#1ab394',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Cancel it!'
                }).then((result) => {
                    if (result.value) {
                        this.isHideSpinner = "";
                        this.$parent.selectedTable.status= 0;
                        let param = new URLSearchParams();
                        param.append("table_id", this.$parent.selectedTable.id);
                        param.append("table_status", this.$parent.selectedTable.status);
                        this.$http.post(this.$store.state.mainAppURL + "pos/update_table_status", param).then(resp => {
                            if(resp.data){
                                localStorage.removeItem(this.selectedBranch.id + "_" +this.selectedTable.id);
                                $("#"+ this.selectedTable.id).removeClass("red-bg");
                                swal("SUCCESS!", "Order has been successfully canceled", "success");
                            }else{
                                swal("Error!", "Invalid Placement", "error");
                            }
                            this.isHideSpinner = "hide";
                        }).catch(ex => {
                            this.isHideSpinner = "hide";
                            swal("Error!", ex + " Please try again or Contact DVM Tech Support", "error");
                        });
                    }
                });
            },
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.c2d_cont_1{
    height: 205px !important;
    overflow: auto;
}
.blocking_overlay{
    position: absolute;
    display: block;
    width: 96%;
    height: 100%;
    top: 2px;
    left: 12px;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
    z-index: 2;
    cursor: not-allowed;
    opacity: 0.75;
}
.blocking_overlay i{
    font-size: 125px;
    line-height: 1.85;
    color: #f9204b;
}
.hideTableBottom > tbody > tr > td{
    border-top: 0 !important;
}
.cart_table > tbody > tr > td{
    padding: 5px;
    white-space: nowrap;
}
.increaseLineHeight{
    line-height: 2;
}

.spinner {
    width: 100px;
}
.spinner input {
    text-align: right;
}
.input-group-btn-vertical {
    position: relative;
    white-space: nowrap;
    width: 1%;
    vertical-align: middle;
    display: table-cell;
}
.input-group-btn-vertical > .btn {
    display: block;
    float: none;
    width: 100%;
    max-width: 100%;
    padding: 8px;
    margin-left: -1px;
    position: relative;
    border-radius: 0;
}
.input-group-btn-vertical > .btn:first-child {
    border-top-right-radius: 4px;
}
.input-group-btn-vertical > .btn:last-child {
    margin-top: -2px;
    border-bottom-right-radius: 4px;
}
.input-group-btn-vertical i{
    position: absolute;
    top: 0;
    left: 4px;
}
#complaint_alert{
    width: 27%;
    position: fixed;
    bottom: 0;
    right: 42px;
}
.list-group-item{
    padding: 5px 15px !important;
}
.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9{
    padding-right: 4px !important;
    padding-left: 4px !important;
}
    .instruction_text{
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>
